module.exports = __webpack_public_path__ + "img/cover-redeem-bg.b4e6edbb.png";